import { useState, useCallback, useEffect } from "react";
import { supabase, isSupabaseEnabled } from "../lib/supabase";

export interface FeatureFlag {
  flag: string;
  enabled: boolean;
  user_emails: string[];
  description: string;
}

interface UseAllFeatureFlagsResult {
  flags: FeatureFlag[];
  loading: boolean;
  refresh: () => Promise<void>;
}

/**
 * Fetches all rows from the feature_flags table.
 * Used only by the Settings → Admin panel.
 */
export function useAllFeatureFlags(): UseAllFeatureFlagsResult {
  const [flags, setFlags] = useState<FeatureFlag[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isSupabaseEnabled() || !supabase) return;
    setLoading(true);
    try {
      const { data } = await supabase
        .from("feature_flags")
        .select("*")
        .order("flag");
      setFlags((data as FeatureFlag[]) ?? []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { flags, loading, refresh };
}
